/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FAQComponent } from 'src/app/FAQ/FAQ.component';
import { Path } from 'src/app/_common/constant/page-const';
import { CommonService } from 'src/refresh/service/common-service';
import { LightBox } from '../light-box/light-box.component';
declare let gtag: any;

@Component({
  selector: 'vision-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit {
  public copyrightYear: string;
  public buildVer:string;
  faqPath = Path.FAQ;
  isOpened:boolean = false;

  FAQComponent = FAQComponent;

  @ViewChild(LightBox) box: LightBox;

  constructor(public commonService: CommonService,
      protected router: Router) {
        //close the FAQ lightbox when ORG link is clicked on Lightbox
        this.commonService.getCloseLightBox().subscribe((r) =>
            this.onMyClose()
        );
        this.commonService.getOpenLightBox().subscribe((r) => {
            this.box.open();
            this.isOpened = true; }
        );

        this.commonService.setFAQClose( () => {
             this.onMyClose()
        });
      }

  onFAQOpen(event: MouseEvent) {

        console.log( "FAQ.open");
        gtag('event', '', {
             'event_label'   : '',
             'event_category': ''
        });                 

        if(this.router.isActive(Path.SINMain, true) ||
        this.router.isActive(Path.SINAreYouSure, true)){
            event.preventDefault();
            this.commonService.expandFaqSection('faqSIN', '');
            this.box.open();
        } else if(this.router.isActive(Path.CCBMain, true) ||
       this.router.isActive(Path.CCBAreYouSure, true)){
            event.preventDefault();
            this.commonService.expandFaqSection('faqCCB', '');
            this.box.open();
        } else if(this.router.isActive(Path.ESRMain, true) ||
        this.router.isActive(Path.ESRAreYouSure, true)){
             event.preventDefault();
             this.commonService.expandFaqSection('faqESR', '');
             this.box.open();
         } else {
            event.preventDefault();
            this.box.open();
        }
        this.isOpened = true;
 }

 onMyClose() { 

      if ( this.isOpened ) {
           this.box.close();
           this.isOpened = false;
      }
 }   

  ngOnInit(): void {
    this.copyrightYear = "{copyrightYear : '" + this.getCurrentYear() + "'}";
  }

  @HostListener('document:keydown.escape', ['$event'])
      public escape(){
            if(this.isOpened) {
                  this.onMyClose();
            }
  }

  getCurrentYear() {
    let year = new Date().getFullYear().toString();
    // return "2012-" + year.substring(2);
    return year;
  }
}
